import { client } from '../../client';
import RequestService, { getQueryURL } from '../requestService';
import { Organisering, PaginatedResult } from '../../../models';
import { OrganiseringLight } from '../../../models/organiseringLight';


export default class OrganiseringService extends RequestService<Organisering, 'organisering'> {
    organiseringLight =
        async (q: string) => client.get<PaginatedResult<OrganiseringLight>>(getQueryURL(`${this.serviceName}/light`, {
            disablePagination: true,
            q
        }
        )
        );
    ikkeValgbareAdmEnheter =
        async (organiseringId: number) =>
            await client.get<string[]>((`${this.serviceName}/hentIkkeValgbareAdmEnher/${organiseringId as number}`));

}
